import React from "react";

/**
 * Multi-option pill row — replaces a <select> where selection is optional.
 * Clicking a selected pill deselects it (sets value to "").
 * Props:
 *   name     string              — field name
 *   value    string              — current selected value (or "" for none)
 *   options  [{value, label}]    — options to display as pills
 *   onChange fn                  — receives synthetic event { target: { name, value } }
 */
export default function PillSelector({ name, value, options, onChange }) {
  const handleClick = (optValue) => {
    // clicking the already-selected pill deselects it
    const next = value === optValue ? "" : optValue;
    onChange({ target: { name, value: next } });
  };

  return (
    <div className="pill-selector">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`pill-selector-btn${value === opt.value ? " selected" : ""}`}
          onClick={() => handleClick(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
